// extracted by mini-css-extract-plugin
export default {"marker":"U5154"};